import { render, staticRenderFns } from "./EmptyIcon.vue?vue&type=template&id=90bc7664&scoped=true&"
import script from "./EmptyIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyIcon.vue?vue&type=script&lang=js&"
import style0 from "./EmptyIcon.vue?vue&type=style&index=0&id=90bc7664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bc7664",
  null
  
)

export default component.exports